module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms27u"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    ref: "hrms27uIndexSearchBoxTable",
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms27uIndex,
      "searchBoxAlias": "hrms27u",
      "approveEvent": _vm.approveEvent,
      "editInlineEventBool": true,
      "saveInlineEvent": _vm.callSave,
      "saveInlineBtnDisp": false,
      "columnEvent": _vm.columnEvent
    },
    on: {
      "setDataRowIndex": function($event) {
        _vm.searchIndexDataRow = arguments[0]
      }
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('input', {
    ref: "popupRequest",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hrms27u-popup-request",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    ref: "popupApplinf",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hrms27u-popup-applinf",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms27u-popup-request",
      "id": "hrms27u-popup-request",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.stdreqLabels[_vm.dash.nowLang]['STD_REQP1']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('stdreq-detail', {
    attrs: {
      "data": _vm.stdreqIndex,
      "labels": _vm.stdreqLabels[_vm.dash.nowLang],
      "columns": _vm.stdreqColumn[_vm.dash.nowLang].index
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms27u-popup-applinf",
      "id": "hrms27u-popup-applinf",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.stdapplinfLabels[_vm.dash.nowLang]['HRRC21P1']['1170']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('stdapplinf-detail', {
    attrs: {
      "data": _vm.stdapplinfIndex,
      "labels": _vm.stdapplinfLabels[_vm.dash.nowLang],
      "columns": _vm.stdapplinfColumn[_vm.dash.nowLang],
      "dataTappoinf": _vm.dataTappoinf,
      "receivedStdapplinfTappoinf": _vm.receivedStdapplinfTappoinf
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51baa327!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms27u/component.vue
// module id = 3755
// module chunks = 1